import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GoogleAuthService } from '../services/google-auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(GoogleAuthService);
  const router = inject(Router);
  if (auth.isSignedIn()) return true;
  return router.createUrlTree(['/login']);
};
